import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'IrisInteractiveVizNavLazy',
        path: () => path.join(__dirname, './InteractiveVizNav'),
        resolve: () => require.resolveWeak('./InteractiveVizNav'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "IrisInteractiveVizNavLazy" */ './InteractiveVizNav'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
